import { useState } from "react";
import { TitleWithParagraph } from "../TitleWithParagraph/TitleWithParagraph";
import { EditAboutUs } from "./EditAboutUs";
import { SlideOut } from "../SlideOut/SlideOut";
import styled from "styled-components/macro";
import { EditButton, PrimaryButtonLarge } from "../Buttons/Buttons";
import type { IHomePageData } from "../../pages/public/HomePage/HomePage";
import { Link } from "react-router-dom";
import { useRoutePath } from "../../util/Routing";
import { useAuthContext } from "../Auth";
import { screenSize } from "../../theme";
import { useTranslation } from "react-i18next";
import { Edit } from "../HeroSection/HeroComponent";

export interface IAboutUsProps {
  isEditable?: boolean;
  homePageData: IHomePageData;
}

export interface IAboutUsData {
  title?: string;
  description: string;
}
const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: ${({ theme }) => theme.resolve("spacing_none")};
  h3 {
    margin-top: 0;
  }
`;

const ButtonContainer = styled.div`
  padding: 35px ${({ theme }) => theme.resolve("spacing_none")};
  display: inline-block;
  button {
    margin-bottom: ${({ theme }) => theme.resolve("spacing_2xl")};
    margin-right: ${({ theme }) => theme.resolve("spacing_2xl")};
  }
  @media ${screenSize.small} {
    a {
      display: block;
      margin-right: 0;
    }
    button,
    button:disabled {
      width: 100%;
      margin-bottom: ${({ theme }) => theme.resolve("spacing_2xl")};
      margin-right: 0;
    }
  }
`;

export const AboutUs = ({ isEditable, homePageData }: IAboutUsProps) => {
  const { t } = useTranslation();
  const [editMode, setEditMode] = useState(false);
  const startEditMode = () => setEditMode(true);
  const endEditMode = () => setEditMode(false);
  const { storePath } = useRoutePath();
  const { roleIsSomeKindOfSeller } = useAuthContext();

  const component = homePageData.config.components.find(
    (component) => component.name === "about_us"
  );
  const data = component?.data;
  const title: string = data?.title;
  const description = data?.desc;

  return (
    <Container>
      <SlideOut
        title={t("Edit About Us")}
        closeFlyout={endEditMode}
        show={editMode}
      >
        <EditAboutUs endEditMode={endEditMode} homePageData={homePageData} />
      </SlideOut>
      {isEditable && (
        <Edit>
          <EditButton
            testid={"edit-about-us-section"}
            onClick={startEditMode}
          />
        </Edit>
      )}
      {(title || description) && (
        <TitleWithParagraph desc={description} title={title} />
      )}
      <ButtonContainer>
        {roleIsSomeKindOfSeller ? (
          <>
            <PrimaryButtonLarge disabled>Contact Us</PrimaryButtonLarge>
            <PrimaryButtonLarge disabled>Register Now</PrimaryButtonLarge>
          </>
        ) : (
          <>
            <Link to={`${storePath}/contact-us`}>
              <PrimaryButtonLarge>Contact Us</PrimaryButtonLarge>
            </Link>
            <Link to={`${storePath}/register`}>
              <PrimaryButtonLarge>Register Now</PrimaryButtonLarge>
            </Link>
          </>
        )}
      </ButtonContainer>
    </Container>
  );
};
